const ContextoFiltros = ({ patologiaNombre, zonaNombre }) => {
  if (!patologiaNombre && !zonaNombre) return null;

  return (
    <div className="listado-contexto">
      {patologiaNombre && (
        <div>
          Filtrando por patología activa: <span style={{ color: "#2a6f97" }}>{patologiaNombre}</span>
        </div>
      )}

      {zonaNombre && (
        <div>
          Filtrando por zona activa: <span style={{ color: "#2a6f97" }}>{zonaNombre}</span>
        </div>
      )}
    </div>
  );
};

export default ContextoFiltros;
